import type MapProperty from '../private/IMapProperty';
import type ISiteObjectDto_Api from './SiteObjectDto.api';
import type { ISiteObjectDto_SourceProps } from './SiteObjectDto.if';

/**
 * @description array of each field & how to convert between external(api) & internal representations
 */
const MAPPINGS: MapProperty[] = [
    {
        localName: 'id',

        defaultValue: 0,
    },
    {
        localName: 'name',

        defaultValue: '',
    },
    {
        localName: 'int1',

        defaultValue: 0,
    },
    {
        localName: 'int2',

        defaultValue: 0,
    },
    {
        localName: 'int3',

        defaultValue: 0,
    },
    {
        localName: 'int4',

        defaultValue: 0,
    },
    {
        localName: 'altBoolean1',

        defaultValue: false,
    },
    {
        localName: 'altBoolean2',

        defaultValue: false,
    },
    {
        localName: 'isUniversal',

        defaultValue: false,
    },
    {
        localName: 'keypadNumber',

        defaultValue: 0,
    },
    {
        localName: 'siteId',

        defaultValue: 0,
    },
    {
        localName: 'siteObjectTypeId',

        defaultValue: 0,
    },
    {
        localName: 'beaconId',

        defaultValue: 0,
    },
    {
        localName: 'beaconSensitivityId',

        defaultValue: 0,
    },
    {
        localName: 'fontSize',

        defaultValue: 0,
    },
    {
        localName: 'fontFamily',

        defaultValue: '',
    },
    {
        localName: 'fontColor',

        defaultValue: '',
    },
    {
        localName: 'menuPosition',

        defaultValue: 0,
    },
    {
        localName: 'nextObjectId',

        defaultValue: 0,
    },
    {
        localName: 'relatedObject1Id',

        defaultValue: 0,
    },
    {
        localName: 'relatedObject2Id',

        defaultValue: 0,
    },
    {
        localName: 'relatedObject3Id',

        defaultValue: 0,
    },
    {
        localName: 'relatedObject4Id',

        defaultValue: 0,
    },
    {
        localName: 'relatedObject5Id',

        defaultValue: 0,
    },
    {
        localName: 'removeForegroundImage',

        defaultValue: false,
    },
    {
        localName: 'foregroundImageMediumId',

        defaultValue: '',
    },
    {
        localName: 'foregroundImageFileName',

        defaultValue: '',
    },
    {
        localName: 'removeBackgroundImage',

        defaultValue: false,
    },
    {
        localName: 'backgroundImageMediumId',

        defaultValue: '',
    },
    {
        localName: 'backgroundImageFileName',

        defaultValue: '',
    },
    {
        localName: 'removeMenuImage',

        defaultValue: false,
    },
    {
        localName: 'menuImageMediumId',

        defaultValue: '',
    },
    {
        localName: 'menuImageFileName',

        defaultValue: '',
    },
    {
        localName: 'namePropagation',

        defaultValue: false,
    },
    {
        localName: 'longNamePropagation',

        defaultValue: false,
    },
    {
        localName: 'descriptionPropagation',

        defaultValue: false,
    },
    {
        localName: 'alternativeText1Propagation',

        defaultValue: false,
    },
    {
        localName: 'alternativeText2Propagation',

        defaultValue: false,
    },
    {
        localName: 'mediumPropagation',

        defaultValue: false,
    },
    {
        localName: 'mediumFileName',

        defaultValue: '',
    },
    {
        localName: 'removeMedium',

        defaultValue: false,
    },
    {
        localName: 'backgroundColor',

        defaultValue: '',
    },
    {
        localName: 'foregroundColor',

        defaultValue: '',
    },
    {
        localName: 'styleId',

        defaultValue: 0,
    },
    {
        localName: 'toursCount',

        defaultValue: 0,
    },
    {
        localName: 'publishedToursCount',

        defaultValue: 0,
    },
    {
        localName: 'deleted',

        defaultValue: false,
    },
    {
        localName: 'screenOrientations',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'keywords',

        defaultValue: [],

        customImport: function (sourceInput: Record<string, unknown>): unknown {
            const dataSource = sourceInput as Partial<ISiteObjectDto_Api>;

            const keywords: ISiteObjectDto_SourceProps['keywords'] = (
                dataSource.siteObjectKeywords ?? []
            ).map(keyword => keyword.name);

            return keywords;
        },

        customExport: function (sourceInput: Record<string, unknown>): unknown {
            const dataSource = sourceInput as Partial<ISiteObjectDto_SourceProps>;

            /* Some information is lost on import, so we just have to do the best we can, just clear the values */
            const siteObjectKeywords: ISiteObjectDto_Api['siteObjectKeywords'] = (
                dataSource.keywords ?? []
            ).map(keyword => ({ name: keyword, id: 0, siteId: 0, isTag: null }));

            return siteObjectKeywords;
        },
    },
    {
        localName: 'isSiteObjectV2',

        defaultValue: false,
        optional: true,
    },
    {
        localName: 'siteObjectTypeV2Id',

        defaultValue: 0,
        optional: true,
    },
];

export default MAPPINGS;
